/*
 * @Author: Zhouqi
 * @Date: 2025-11-05 10:44:07
 * @LastEditors: Ryan
 * @LastEditTime: 2026-01-16
 */
import dynamic from 'next/dynamic';
import React from 'react';

import VideoTranslatorSkeleton from '@/3.0/video-translator/_components/video-translator-skeleton';
import { Introduction } from '@/components/container';
import DelayedRender from '@/components/DelayRender';
import Footer from '@/components/Footer';
import Layout from '@/components/layout';
import SEOHead from '@/landing/components/SEOHead';
import { createSoftwareAppSchema } from '@/landing/utils/structuredData';

const VideoTranslation = dynamic(() => import('../../3.0/video-translator/entry'), {
  ssr: false,
  loading: () => (
    <DelayedRender>
      <VideoTranslatorSkeleton />
    </DelayedRender>
  ),
});

const SEOSections = dynamic(() => import('../../3.0/video-translator/seo'), {
  ssr: true,
});

// SEO 常量
const PAGE_TITLE = 'AI Video Translator - Translate Videos to 35+ Languages | FalcoCut';
const META_DESCRIPTION =
  'Translate videos into 35+ languages with AI-powered voice cloning, lip sync, and subtitles. FalcoCut makes video localization fast, accurate, and affordable.';
const CURRENT_URL = 'https://falcocut.ai/video-translator';

// 结构化数据
const structuredData = createSoftwareAppSchema({
  name: 'FalcoCut AI Video Translator',
  description: META_DESCRIPTION,
  url: CURRENT_URL,
  ratingValue: '4.9',
  ratingCount: '3150',
  featureList: [
    'Translate videos to 35+ languages',
    'AI voice cloning and dubbing',
    'Automatic lip sync',
    'Subtitle generation and editing',
    'Multi-speaker detection',
    'Batch video translation',
  ],
});

const VideoTranslationPage: React.FC & {
  getLayout?: (page: React.ReactElement) => React.ReactNode;
  getExtraContent?: () => React.ReactNode;
} = () => {
  return (
    <>
      <SEOHead
        title={PAGE_TITLE}
        description={META_DESCRIPTION}
        url={CURRENT_URL}
        imageAlt="FalcoCut AI Video Translator"
        publishedTime="2025-11-05"
        modifiedTime="2026-01-16"
        structuredData={structuredData}
      />

      <VideoTranslation />
    </>
  );
};

// 定义 getLayout 为直接返回页面本身，不使用 Layout
VideoTranslationPage.getLayout = (page: React.ReactElement) => <Layout>{page}</Layout>;

// 定义 SEO 部分和 Footer 作为额外内容，在 Layout 外渲染
VideoTranslationPage.getExtraContent = () => {
  return (
    <Introduction>
      <SEOSections />
      <Footer />
    </Introduction>
  );
};

export const getStaticProps = async () => {
  return {
    props: {},
  };
};

export default VideoTranslationPage;
